import { IncomingMessage } from 'http';

import { QueryFunctionContext, QueryKey } from '@tanstack/react-query';

import { fetchFaqs } from '../../../services/faqs';

const getFaqs = (
  options: {
    locale: string;
    slug: string;
  },
  req?: IncomingMessage
): [
  QueryKey,
  (options: QueryFunctionContext) => ReturnType<typeof fetchFaqs>
] => [
  ['faqs', { ...options }],
  ({
    queryKey: [, key],
  }: {
    queryKey: [string, { locale: string; slug: string }];
  }) => fetchFaqs(key, req),
];

export default getFaqs;
